import { Dialog, DialogHeading } from 'omakase';
import { consumer } from '@tock/coretypes';
import BusinessPlaylistsDialogNewListPage from 'components/profile/playlists/BusinessPlaylistsDialogListPage';

interface Props {
  isOpen: boolean;
  onClose(): void;
  playlist?: consumer.Playlist;
}

const EditPlaylistDialog: React.FunctionComponent<Props> = ({ isOpen, onClose, playlist }) => {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogHeading onClose={onClose}>Edit List</DialogHeading>
      <BusinessPlaylistsDialogNewListPage playlist={playlist} onSaveDone={onClose} />
    </Dialog>
  );
};

export default EditPlaylistDialog;
